// extracted by mini-css-extract-plugin
module.exports = {"chatWrap":"ChatHistoryModal_style_chatWrap__3Obs3","chatWrapNew":"ChatHistoryModal_style_chatWrapNew__j5Q3M"};